<template>
  <div>
    <el-form ref="form">
      <div>
        <el-space wrap>
          <el-form-item label="板块:">
            <el-select v-model="obj.selectedBlockValue" @change="handleSelectChange" style="width:120px" disabled="true">
              <el-option v-for="item in obj.selectBlockList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="handleSubmit" style="width:80px">
              <el-icon class="el-input__icon">
                <refresh /> 筛 选
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </div>
      <el-tag type="warning" size="small" style="margin-bottom: 20px;">最多可添加8个条件，请注意指标单位</el-tag>
      <div>
        <el-space wrap>
          <el-form-item label="基本指标:">
            <el-select v-model="obj.basicValue" @change="handleBasicValueChange" placeholder="请选择" style="width:200px">
              <el-option v-for="item in obj.basicList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="obj.basicDayValue" @change="handleBasicDayValueChange" placeholder="范围"
              style="width:120px">
              <el-option v-for="item in obj.basicDayList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="obj.basicSymbolsValue" @change="handleBasicSymbolsChange" placeholder="符号"
              style="width:100px">
              <el-option v-for="item in obj.symbolsList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input-number v-model="obj.basicAmount" placeholder="数量" style="width: 160px;">
            </el-input-number>
            <el-button type="primary" @click="handleAddBasic">
              <el-icon class="el-input__icon">
                <refresh /> 添加
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </div>
      <div>
        <el-space wrap>
          <el-form-item label="收益指标:">
            <el-select v-model="obj.selectedJRValue" placeholder="请选择" @change="handleJRChange" style="width:200px">
              <el-option v-for="item in obj.selectJRList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="obj.selectedJRDayValue" placeholder="范围" @change="handleJRDayChange" style="width:120px">
              <el-option v-for="item in obj.selectJRDayList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="obj.selectedJRSymbolsValue" placeholder="符号" @change="handleJRSymbolsChange"
              style="width:100px">
              <el-option v-for="item in obj.symbolsList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input-number v-model="obj.selectedJRAmount" placeholder="数量" style="width: 160px;">
            </el-input-number>
            <el-button type="primary" @click="handleAddJR">
              <el-icon class="el-input__icon">
                <refresh /> 添加
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </div>
      <div>
        <el-space wrap>
          <el-form-item label="技术指标:">
            <el-select v-model="obj.indicatorsValue" placeholder="请选择" @change="handleTechnicalChange"
              style="width:180px">
              <el-option-group v-for="group in obj.indicatorsList" :key="group.label" :label="group.label">
                <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" />
              </el-option-group>
            </el-select>
            <el-button type="primary" @click="handleAddTechnical">
              <el-icon class="el-input__icon">
                <refresh /> 添加
              </el-icon>
            </el-button>
          </el-form-item>
          <el-form-item label="形态指标:">
            <el-select v-model="obj.patternsValue" placeholder="请选择" @change="handlePatternChange" style="width:155px">
              <el-option-group v-for="group in obj.patternsList" :key="group.label" :label="group.label">
                <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" />
              </el-option-group>
            </el-select>
            <el-button type="primary" @click="handleAddPattern">
              <el-icon class="el-input__icon">
                <refresh /> 添加
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </div>
      <div style="width: 1400px;">
        <el-space wrap>
          <el-form-item label="" v-for="data in obj.pickingList" :key="data">
            <el-input v-model="data.label" :disabled="true" style="width:260px" />
            <el-button type="danger" @click="del(data)">删除</el-button>
          </el-form-item>
        </el-space>
      </div>
      <el-tag type="warning" size="small" v-if="obj.date !== ''">数据截至到 {{ obj.date }}</el-tag>
      <div>
        <el-table :data="obj.dataList" height="100%" style="width: 100%" empty-text=" "
          :style="'height:' + (this.$store.state.windowHeight - 480) + 'px'" :cell-style="cellStyle"
          @row-click="handleRowClick">
          <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
          <el-table-column fixed label="名称" prop="name" width="140px" align="right" sortable />
          <el-table-column label="代码" prop="symbol" width="100px" align="right" sortable />
          <el-table-column label="最新" prop="close" width="80px" align="right" />
          <el-table-column label="涨跌" prop="chg" width="80px" align="right" :sort-method="customStrSort" sortable />
          <el-table-column label="涨跌幅" prop="chgPct" width="90px" align="right" :sort-method="customPctSort" sortable />
          <el-table-column label="开盘" prop="open" width="80px" align="right" />
          <el-table-column label="最低" prop="low" width="80px" align="right" />
          <el-table-column label="最高" prop="high" width="80px" align="right" />
          <el-table-column label="成交量" prop="vol" width="90px" align="right" :sort-method="customVolSort" sortable />
          <el-table-column label="持仓量" prop="opi" width="90px" align="right" :sort-method="customOpiSort" sortable />
          <el-table-column label="增仓" prop="opiChg" width="80px" align="right" sortable />
          <el-table-column label="前结" prop="preSett" width="80px" align="right" />
          <el-table-column label="前收" prop="preClose" width="80px" align="right" />
          <el-table-column label="趋势度" prop="trend" width="100px" align="right" sortable/>
          <el-table-column label="振幅" prop="amplitude" width="80px" align="right" :sort-method="customAmplitudeSort" sortable/>
          <el-table-column label="成交额" prop="turnover" width="90px" align="right" :sort-method="customTurnoverSort" sortable/>
        </el-table>
      </div>
    </el-form>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { http } from '../util/http'
import { bigNumberTransform, formatDecimalPoint } from '../util/base'
import { ElMessage } from 'element-plus'
import { findObjByField } from '../util/base'
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const chartDomRef = ref()
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      total: 0,
      page: 1,
      limit: 11,
      selectBlockList: [
        {
          value: 'all',
          label: '全部'
        }
      ],
      selectedBlockValue: 'all',
      // 基本指标
      basicList: [
        {
          value: 'chgPct',
          label: '涨跌幅(结算价)(%)'
        },
        {
          value: 'chg2Pct',
          label: '涨跌幅(收盘价)(%)'
        },
        {
          value: 'chg3Pct',
          label: '实体涨跌幅(%)'
        },
        {
          value: 'amplitude',
          label: '振幅(%)'
        },
        {
          value: 'amplitudePoint',
          label: '振幅点数'
        },
        {
          value: 'trend',
          label: '趋势度'
        },
        {
          value: 'volOpi',
          label: '投机度(均值)'
        },
        {
          value: 'vol',
          label: '成交量'
        },
        {
          value: 'volChg',
          label: '成交量增量'
        },
        {
          value: 'volChgPct',
          label: '成交量增幅(%)'
        },
        {
          value: 'turnover',
          label: '成交额'
        },
        {
          value: 'turnoverChg',
          label: '成交额增量'
        },
        {
          value: 'turnoverChgPct',
          label: '成交额增幅(%)'
        },
        {
          value: 'opi',
          label: '持仓量(均值)'
        },
        {
          value: 'opiChg',
          label: '持仓量增量'
        },
        {
          value: 'opiChgPct',
          label: '持仓量增幅(%)'
        },
        {
          value: 'opiCapital',
          label: '沉淀资金(均值)'
        },
        {
          value: 'opiCapitalChg',
          label: '资金流入增量'
        },
        {
          value: 'opiCapitalChgPct',
          label: '资金流入增幅(%)'
        }
      ],
      basicValue: '',
      basicLabel: '',
      basicDayList: [
      {
          value: '1',
          label: '最近1日'
        },
        {
          value: '3',
          label: '最近3日'
        },
        {
          value: '5',
          label: '最近5日'
        },
        {
          value: '10',
          label: '最近10日'
        },
        {
          value: '20',
          label: '最近20日'
        },
        {
          value: '30',
          label: '最近30日'
        },
        {
          value: '40',
          label: '最近40日'
        },
        {
          value: '50',
          label: '最近50日'
        },
        {
          value: '60',
          label: '最近60日'
        }
      ],
      basicDayValue: '',
      basicDayLabel: '',
      basicSymbolsValue: "",
      basicSymbolsLabel: "",
      basicAmount: "",
      // 技术指标
      indicatorsList: [
        {
          label: 'MA指标',
          options: [
            {
              value: 'MA_2_LONG',
              label: 'MA多头排列(2均线)'
            },
            {
              value: 'MA_2_SHORT',
              label: 'MA空头排列(2均线)'
            },
            // {
            //   value: 'MA_3_LONG',
            //   label: 'MA多头排列(3均线)'
            // },
            // {
            //   value: 'MA_3_SHORT',
            //   label: 'MA空头排列(3均线)'
            // },
            {
              value: 'MA_LONG',
              label: 'MA多头排列(3均线)'
            },
            {
              value: 'MA_SHORT',
              label: 'MA空头排列(3均线)'
            },
            {
              value: 'MA_CROSSUP',
              label: 'MA金叉'
            },
            {
              value: 'MA_CROSSDOWN',
              label: 'MA死叉'
            },
            {
              value: 'Up_MA1',
              label: 'MA5上方收盘'
            },
            {
              value: 'Down_MA1',
              label: 'MA5下方收盘'
            },
            {
              value: 'Up_MA2',
              label: 'MA10上方收盘'
            },
            {
              value: 'Down_MA2',
              label: 'MA10下方收盘'
            },
            {
              value: 'Up_MA3',
              label: 'MA20上方收盘'
            },
            {
              value: 'Down_MA3',
              label: 'MA20下方收盘'
            }
          ],
        },
        {
          label: 'BOLL指标',
          options: [
            {
              value: 'UP_BOLL_MID',
              label: '布林中轨上方收盘'
            },
            {
              value: 'DOWN_BOLL_MID',
              label: '布林中轨下方收盘'
            },
            {
              value: 'BOLL_CROSSUP_MID',
              label: '突破布林中轨'
            },
            {
              value: 'BOLL_CROSSDOWN_MID',
              label: '跌破布林中轨'
            },
          ],
        },
        {
          label: 'MACD指标',
          options: [
            {
              value: 'MACD_CROSSUP',
              label: 'MACD上穿'
            },
            {
              value: 'MACD_CROSSDOWN',
              label: 'MACD下穿'
            },
            {
              value: 'MACD_RED',
              label: 'MACD红柱'
            },
            {
              value: 'MACD_GREEN',
              label: 'MACD绿柱'
            },
          ],
        },
        {
          label: 'KDJ指标',
          options: [
            {
              value: 'KDJ_CROSSUP',
              label: 'KDJ上穿'
            },
            {
              value: 'KDJ_CROSSDOWN',
              label: 'KDJ下穿'
            },
          ],
        },
      ],
      indicatorsValue: '',
      indicatorsLabel: '',
      // 形态指标
      patternsList: [
        {
          label: '三k线组合',
          options: [
            {
              value: 'MorningStar',
              label: '早晨之星'
            },
            {
              value: 'EveningStar',
              label: '黄昏之星'
            },
          ],
        },
        {
          label: '两k线组合',
          options: [
            {
              value: 'EngulfingUp',
              label: '看涨吞没'
            },
            {
              value: 'EngulfingDown',
              label: '看跌吞没'
            },
            {
              value: 'Piercing',
              label: '向上刺透'
            },
            {
              value: 'DarkCloudCover',
              label: '乌云压顶'
            },
          ],
        },
        {
          label: '单k线模式',
          options: [
            {
              value: 'MarubozuUp',
              label: '实体饱满阳'
            },
            {
              value: 'MarubozuDown',
              label: '实体饱满阴'
            },
            {
              value: 'Hammer',
              label: '锤子形态'
            },
            {
              value: 'ShootingStar',
              label: '流星形态'
            },
            {
              value: 'Dragonfly',
              label: '蜻蜓十字'
            },
            {
              value: 'Gravestone',
              label: '墓碑十字'
            },
            {
              value: 'Dojistar',
              label: '十字星'
            },
          ],
        },
        {
          label: '其他',
          options: [
            {
              value: 'up',
              label: '收阳'
            },
            {
              value: 'down',
              label: '收阴'
            },
            {
              value: '2up',
              label: '二连阳'
            },
            {
              value: '2down',
              label: '二连阴'
            },
            {
              value: '3up',
              label: '三连阳'
            },
            {
              value: '3down',
              label: '三连阴'
            },
          ],
        },
      ],
      patternsValue: '',
      patternsLabel: '',
      // 金融指标
      selectJRList: [
        {
          value: 'rtn',
          label: '收益率(%)(对数收益率)'
        },
        {
          value: 'std',
          label: '波动率(%)'
        },
        {
          value: 'sharp',
          label: '夏普比(收益率/波动率)'
        },
        // {
        //   value: 'alpha',
        //   label: 'Alpha'
        // },
        // {
        //   value: 'beta',
        //   label: 'Beta'
        // },
        // {
        //   value: 'correlation',
        //   label: '相关系数'
        // },
      ],
      selectedJRValue: '',
      selectedJRLabel: '',
      selectJRDayList: [
        {
          value: '5',
          label: '最近5日'
        },
        {
          value: '10',
          label: '最近10日'
        },
        {
          value: '20',
          label: '最近20日'
        },
        {
          value: '30',
          label: '最近30日'
        },
        {
          value: '40',
          label: '最近40日'
        },
        {
          value: '50',
          label: '最近50日'
        },
        {
          value: '60',
          label: '最近60日'
        }
      ],
      selectedJRDayValue: '',
      selectedJRDayLabel: '',
      selectedJRSymbolsValue: '',
      selectedJRSymbolsLabel: '',
      selectedJRAmount: '',
      // 其他
      symbolsList: [
        {
          value: '>',
          label: '大于'
        },
        {
          value: '>=',
          label: '大于等于'
        },
        {
          value: '<',
          label: '小于'
        },
        {
          value: '<=',
          label: '小于等于'
        },
        {
          value: '!=',
          label: '不等于'
        },
        {
          value: '=',
          label: '等于'
        },
        // {
        //   value: 'head',
        //   label: '前'
        // },
        // {
        //   value: 'tail',
        //   label: '后'
        // },
      ],
      pickingList: [],
      dataList: [],
      date: ''
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      setStore()
    })

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.pickingData === '') {
        // 无缓存，从后台请求数据
        // requestData()
      } else {
        // 有缓存，设定页面状态
        getStore()
      }
    }

    // 后台获取数据
    const requestData = () => {
      var basicPicking = []
      var technicalPicking = []
      var patternPicking = []
      var returnPicking = []
      for (var item of obj.pickingList) {
        if (item.category == "basic") {
          basicPicking.push(item.value)
        } else if (item.category == "technical") {
          technicalPicking.push(item.value)
        } else if (item.category == "pattern") {
          patternPicking.push(item.value)
        } else if (item.category == "return") {
          returnPicking.push(item.value)
        }
      }
      let formData = new FormData()
      formData.append("basic_indicators", basicPicking.join(" "))
      formData.append("technical_indicators", technicalPicking.join(" "))
      formData.append("patterns_indicators", patternPicking.join(" "))
      formData.append("return_indicators", returnPicking.join(" "))
      formData.append("page", obj.page)
      formData.append("limit", obj.limit)
      http({
        url: `/picking`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data)
        if (res.data.data.length === 0) {
          ElMessage.info('没有符合条件的合约')
        }
        processData(res.data)
        setStore()
      }).catch((err) => {
        obj.dataList = []
        obj.date = ''
        setStore()
      })
    }

    // 处理数据
    const processData = (data) => {
      let no = 1
      data.data.forEach((item) => {
        obj.date = item.date
        if (item.chgPct !== "-") {
          item.chgPct = (item.chgPct * 100).toFixed(2) + '%'
          item.volForSort = parseFloat(item.vol)
          item.opiForSort = parseFloat(item.opi)
          item.vol = bigNumberTransform(parseFloat(item.vol))
          item.opi = bigNumberTransform(parseFloat(item.opi))
          item.chg = formatDecimalPoint(parseFloat(item.chg), item.symbol)
          item.close = formatDecimalPoint(parseFloat(item.close), item.symbol)
          item.open = formatDecimalPoint(parseFloat(item.open), item.symbol)
          item.low = formatDecimalPoint(parseFloat(item.low), item.symbol)
          item.high = formatDecimalPoint(parseFloat(item.high), item.symbol)
          item.preSett = formatDecimalPoint(parseFloat(item.preSett), item.symbol)
          item.preClose = formatDecimalPoint(parseFloat(item.preClose), item.symbol)
          item.trend = parseFloat(item.trend.toFixed(2))
          item.amplitude = (item.amplitude * 100).toFixed(2) + '%'
          item.turnoverForSort = parseFloat(item.turnover)
          item.turnover = bigNumberTransform(parseFloat(item.turnover))
        }
        item.no = no
        no++
      })
      obj.total = data.total
      obj.dataList = data.data
    }

    // 保存Store
    const setStore = () => {
      var storeObj = {
        // 基础指标
        'basicValue': obj.basicValue,
        'basicLabel': obj.basicLabel,
        'basicDayValue': obj.basicDayValue,
        'basicDayLabel': obj.basicDayLabel,
        'basicSymbolsValue': obj.basicSymbolsValue,
        'basicSymbolsLabel': obj.basicSymbolsLabel,
        'basicAmount': obj.basicAmount,
        // 技术和形态指标
        'indicatorsValue': obj.indicatorsValue,
        'indicatorsLabel': obj.indicatorsLabel,
        'patternsValue': obj.patternsValue,
        'patternsLabel': obj.patternsLabel,
        // 金融指标
        'selectedJRValue': obj.selectedJRValue,
        'selectedJRLabel': obj.selectedJRLabel,
        'selectedJRDayValue': obj.selectedJRDayValue,
        'selectedJRDayLabel': obj.selectedJRDayLabel,
        'selectedJRSymbolsValue': obj.selectedJRSymbolsValue,
        'selectedJRSymbolsLabel': obj.selectedJRSymbolsLabel,
        'selectedJRAmount': obj.selectedJRAmount,
        'selectJRDayList': obj.selectJRDayList, // 避免切换页面显示失效问题
        // 其他
        'pickingList': obj.pickingList,
        'dataList': obj.dataList,
        'date': obj.date,
        'total': obj.total,
        'page': obj.page,
      }
      store.commit('setPickingData', storeObj)
    }

    // 获取Store
    const getStore = () => {
      // 基础指标
      obj.basicValue = store.state.pickingData.basicValue
      obj.basicLabel = store.state.pickingData.basicLabel
      obj.basicDayValue = store.state.pickingData.basicDayValue
      obj.basicDayLabel = store.state.pickingData.basicDayLabel
      obj.basicSymbolsValue = store.state.pickingData.basicSymbolsValue
      obj.basicSymbolsLabel = store.state.pickingData.basicSymbolsLabel
      obj.basicAmount = store.state.pickingData.basicAmount
      // 技术和形态指标
      obj.indicatorsValue = store.state.pickingData.indicatorsValue
      obj.indicatorsLabel = store.state.pickingData.indicatorsLabel
      obj.patternsValue = store.state.pickingData.patternsValue
      obj.patternsLabel = store.state.pickingData.patternsLabel
      // 金融指标
      obj.selectedJRValue = store.state.pickingData.selectedJRValue
      obj.selectedJRLabel = store.state.pickingData.selectedJRLabel
      obj.selectedJRDayValue = store.state.pickingData.selectedJRDayValue
      obj.selectedJRDayLabel = store.state.pickingData.selectedJRDayLabel
      obj.selectedJRSymbolsValue = store.state.pickingData.selectedJRSymbolsValue
      obj.selectedJRSymbolsLabel = store.state.pickingData.selectedJRSymbolsLabel
      obj.selectedJRAmount = store.state.pickingData.selectedJRAmount
      obj.selectJRDayList = store.state.pickingData.selectJRDayList // 避免切换页面显示失效问题
      // 其他
      obj.pickingList = store.state.pickingData.pickingList
      obj.dataList = store.state.pickingData.dataList
      obj.date = store.state.pickingData.date
      obj.total = store.state.pickingData.total
      obj.page = store.state.pickingData.page
    }

    /**
     * 事件处理区域
     */

    // 下拉框选择事件
    const handleSelectChange = (e) => {
      // requestData()
    }

    // 表格行点击事件
    const handleRowClick = (row) => {
      let name = row.name
      store.commit('setCurrentContract', name)
      router.push(`/candlestick?name=${name}`)
    }

    // 基本指标 指标名
    const handleBasicValueChange = (e) => {
      let tempObj = findObjByField(obj.basicList, 'value', obj.basicValue)
      obj.basicLabel = tempObj.label
    }

    // 基本指标 范围
    const handleBasicDayValueChange = () => {
      let tempObj = findObjByField(obj.basicDayList, 'value', obj.basicDayValue)
      obj.basicDayLabel = tempObj.label
    }

    // 基本指标 符号
    const handleBasicSymbolsChange = () => {
      let tempObj = findObjByField(obj.symbolsList, 'value', obj.basicSymbolsValue)
      obj.basicSymbolsLabel = tempObj.label
    }

    // 基本指标添加事件
    const handleAddBasic = () => {
      if (obj.basicValue !== "" && obj.basicDayValue !== "" && obj.basicSymbolsValue !== "" && obj.basicAmount !== null) {
        if (isPickingItemMax()) {
          return
        }
        // if (isPickingItemExist(obj.basicLabel)) {
        //   return
        // }
        // 处理有百分号的情况
        var basicAmountValue = 0
        var basicPickingLabel = ""
        if (obj.basicValue == "chgPct" || obj.basicValue == "chg2Pct" || obj.basicValue == "chg3Pct" || obj.basicValue == "amplitude" || obj.basicValue == "volChgPct" || obj.basicValue == "turnoverChgPct" || obj.basicValue == "opiChgPct" || obj.basicValue == "opiCapitalChgPct") {
          basicAmountValue = obj.basicAmount / 100
          basicPickingLabel = obj.basicLabel + obj.basicDayLabel + obj.basicSymbolsLabel + obj.basicAmount + "%"
        } else if (obj.basicValue == "amplitudePoint") {
          basicPickingLabel = obj.basicLabel + obj.basicDayLabel + obj.basicSymbolsLabel + obj.basicAmount + "元"
        } else if (obj.basicValue == "vol" || obj.basicValue == "volChg" || obj.basicValue == "opi" || obj.basicValue == "opiChg") {
          basicAmountValue = obj.basicAmount * 10000
          basicPickingLabel = obj.basicLabel + obj.basicDayLabel + obj.basicSymbolsLabel + obj.basicAmount + "万手"
        } else if (obj.basicValue == "opiCapital" || obj.basicValue == "opiCapitalChg" || obj.basicValue == "turnover" || obj.basicValue == "turnoverChg") {
          basicAmountValue = obj.basicAmount * 100000000
          basicPickingLabel = obj.basicLabel + obj.basicDayLabel + obj.basicSymbolsLabel + obj.basicAmount + "亿"
        } else {
          basicAmountValue = obj.basicAmount
          basicPickingLabel = obj.basicLabel + obj.basicDayLabel + obj.basicSymbolsLabel + obj.basicAmount
        }
        var basicPickingValue = obj.basicValue + "_ma" + obj.basicDayValue + "," + obj.basicSymbolsValue + "," + basicAmountValue
        var basicPickingType = obj.basicLabel
        
        // 如果指标已经存在则更新，否则做新增
        let exist = false
        for (var item of obj.pickingList) {
          // if (item.type == basicPickingType) {
          //   item.label = basicPickingLabel
          //   item.value = basicPickingValue
          //   exist = true
          // }
          if (item.value == basicPickingValue) {
            ElMessage.error("该指标已被添加")
            exist = true
          } else if (item.value.split(",").slice(0, 2).join(",") == basicPickingValue.split(",").slice(0, 2).join(",")) {
            // 如果指标条件数值不一样，则做更新(chgPct_ma1,<,1 != chgPct_ma1,>,0)
            item.label = basicPickingLabel
            item.value = basicPickingValue
            exist = true
          }
        }
        if (!exist) {
          obj.pickingList.push({ label: basicPickingLabel, value: basicPickingValue, type: basicPickingType, category: "basic" })
        }
        console.log(basicPickingValue)
      }
    }


    // 技术指标 指标名
    const handleTechnicalChange = () => {
      for (var item of obj.indicatorsList) {
        let tempObj = findObjByField(item.options, 'value', obj.indicatorsValue)
        if (tempObj != null) {
          obj.indicatorsLabel = tempObj.label
          break
        }
      }
    }

    // 技术指标添加事件
    const handleAddTechnical = () => {
      if (obj.indicatorsValue !== "") {
        if (isPickingItemMax()) {
          return
        }
        if (isPickingItemExist(obj.indicatorsLabel)) {
          return
        }
        var indicatorsPickingValue = obj.indicatorsValue
        var indicatorsPickingLabel = obj.indicatorsLabel
        var indicatorsPickingType = obj.indicatorsLabel
        obj.pickingList.push({ label: indicatorsPickingLabel, value: indicatorsPickingValue, type: indicatorsPickingType, category: "technical" })
        console.log(indicatorsPickingValue)
      }
    }

    // 形态指标 指标名
    const handlePatternChange = () => {
      for (var item of obj.patternsList) {
        let tempObj = findObjByField(item.options, 'value', obj.patternsValue)
        if (tempObj != null) {
          obj.patternsLabel = tempObj.label
          break
        }
      }
    }

    // 形态指标添加事件
    const handleAddPattern = () => {
      if (obj.patternsValue !== "") {
        if (isPickingItemMax()) {
          return
        }
        if (isPickingItemExist(obj.patternsLabel)) {
          return
        }
        var patternPickingValue = obj.patternsValue
        var patternPickingLabel = obj.patternsLabel
        var patternPickingType = obj.patternsLabel
        obj.pickingList.push({ label: patternPickingLabel, value: patternPickingValue, type: patternPickingType, category: "pattern" })
        console.log(patternPickingValue)
      }
    }

    // 金融指标 指标名
    const handleJRChange = (value) => {
      if (value === "alpha" || value === "beta" || value === "correlation") {
        obj.selectJRDayList = [{ value: '60', label: '最近60日' }]
        obj.selectedJRDayValue = '60'
        obj.selectedJRDayLabel = '最近60日'
        setStore() // 避免切换页面回来，显示失效问题
      } else {
        obj.selectJRDayList = [{ value: '5', label: '最近5日' }, { value: '10', label: '最近10日' }, { value: '20', label: '最近20日' }, { value: '30', label: '最近30日' },{ value: '40', label: '最近40日' },{ value: '50', label: '最近50日' },{ value: '60', label: '最近60日' }]
        obj.selectedJRDayValue = ''
        obj.selectedJRDayLabel = ''
      }
      let tempObj = findObjByField(obj.selectJRList, 'value', obj.selectedJRValue)
      obj.selectedJRLabel = tempObj.label
    }

    // 金融指标 范围
    const handleJRDayChange = () => {
      let tempObj = findObjByField(obj.selectJRDayList, 'value', obj.selectedJRDayValue)
      obj.selectedJRDayLabel = tempObj.label
    }

    // 金融指标 符号
    const handleJRSymbolsChange = () => {
      let tempObj = findObjByField(obj.symbolsList, 'value', obj.selectedJRSymbolsValue)
      obj.selectedJRSymbolsLabel = tempObj.label
    }

    // 金融指标添加事件
    const handleAddJR = () => {
      if (obj.selectedJRValue !== "" && obj.selectedJRDayValue !== "" && obj.selectedJRSymbolsValue !== "" && obj.selectedJRAmount !== null) {
        if (isPickingItemMax()) {
          return
        }
        // if (isPickingItemExist(obj.selectedJRLabel)) {
        //   return
        // }
        // 处理有百分号的情况
        var jrAmountValue = 0
        var jrPickingLabel = ""
        if (obj.selectedJRValue == "rtn" || obj.selectedJRValue == "std") {
          jrAmountValue = obj.selectedJRAmount / 100
          jrPickingLabel = obj.selectedJRLabel + obj.selectedJRDayLabel + obj.selectedJRSymbolsLabel + obj.selectedJRAmount + "%"
        } else {
          jrAmountValue = obj.selectedJRAmount
          jrPickingLabel = obj.selectedJRLabel + obj.selectedJRDayLabel + obj.selectedJRSymbolsLabel + obj.selectedJRAmount
        }
        var jrPickingValue = obj.selectedJRValue + "_ma" + obj.selectedJRDayValue + "," + obj.selectedJRSymbolsValue + "," + jrAmountValue
        var jrPickingType = obj.selectedJRLabel

        // 如果指标已经存在则更新，否则做新增
        let exist = false
        for (var item of obj.pickingList) {
          // if (item.type == jrPickingType) {
          //   item.label = jrPickingLabel
          //   item.value = jrPickingValue
          //   exist = true
          // }
          if (item.value == jrPickingValue) {
            ElMessage.error("该指标已被添加")
            exist = true
          } else if (item.value.split(",").slice(0, 2).join(",") == jrPickingValue.split(",").slice(0, 2).join(",")) {
            // 如果指标条件数值不一样，则做更新(chgPct_ma1,<,1 != chgPct_ma1,>,0)
            item.label = jrPickingLabel
            item.value = jrPickingValue
            exist = true
          }
        }
        if (!exist){
          obj.pickingList.push({ label: jrPickingLabel, value: jrPickingValue, type: jrPickingType, category: "return" })
        }
        console.log(jrPickingValue)
      }
    }

    // 指标项目最大添加数量check
    const isPickingItemMax = () => {
      if (obj.pickingList.length == 8) {
        ElMessage.error("最多只能添加8个指标")
        return true
      }
      return false
    }

    // 指标项目是否已被添加check
    const isPickingItemExist = (pickingItem) => {
      for (var item of obj.pickingList) {
        // console.log(obj.pickingList)
        // console.log(pickingItem)
        if (item.type == pickingItem) {
          ElMessage.error("该指标已被添加")
          return true
        }
      }
      return false
    }

    // 删除品种
    const del = (data) => {
      obj.pickingList.forEach((item) => {
        // console.log(data)
        if (item.value === data.value) {
          // console.log(item.value)
          obj.pickingList.splice(obj.pickingList.indexOf(item), 1)
        }
      })
    }

    // 按钮提交事件
    const handleSubmit = () => {
      if (!formCheck()) {
        return
      }
      requestData()
    }

    // 表单Check处理
    const formCheck = () => {
      if (obj.pickingList.length === 0) {
        ElMessage.error('请至少添加一个筛选条件')
        return false
      }
      return true
    }

    /**
     * 样式设置区域
     */

    // 表格单元格样式
    const cellStyle = (row, column, rowIndex, columnIndex) => {
      if (row.row.chg > 0 && row.columnIndex === 4) {
        return { color: 'red' }
      } else if (row.row.chg < 0 && row.columnIndex === 4) {
        return { color: 'green' }
      }
      if (row.row.chgPct.toString().replace('%', '') > 0 && row.columnIndex === 5) {
        return { color: 'red' }
      } else if (row.row.chgPct.toString().replace('%', '') < 0 && row.columnIndex === 5) {
        return { color: 'green' }
      }
      if (row.row.open > row.row.preSett && row.columnIndex === 6) {
        return { color: 'red' }
      } else if (row.row.open < row.row.preSett && row.columnIndex === 6) {
        return { color: 'green' }
      }
      if (row.row.low > row.row.preSett && row.columnIndex === 7) {
        return { color: 'red' }
      } else if (row.row.low < row.row.preSett && row.columnIndex === 7) {
        return { color: 'green' }
      }
      if (row.row.high > row.row.preSett && row.columnIndex === 8) {
        return { color: 'red' }
      } else if (row.row.high < row.row.preSett && row.columnIndex === 8) {
        return { color: 'green' }
      }
      if (row.row.close > row.row.preSett && row.columnIndex === 3) {
        return { color: 'red' }
      } else if (row.row.close < row.row.preSett && row.columnIndex === 3) {
        return { color: 'green' }
      }
      if (row.row.trend > 0 && row.columnIndex === 14) {
        return { color: 'red' }
      } else if (row.row.trend < 0 && row.columnIndex === 14) {
        return { color: 'green' }
      }
    }

    // 表格排序(文字型的数字列)
    const customStrSort = (a, b) => {
      return parseFloat(a.chg) - parseFloat(b.chg)
    }

    // 表格排序(带百分号的数字列)
    const customPctSort = (a, b) => {
      return parseFloat(a.chgPct.replace('%', '')) - parseFloat(b.chgPct.replace('%', ''))
    }

    // 表格排序(带金额单位的数字列)
    const customVolSort = (a, b) => {
      return a.volForSort - b.volForSort
    }

    // 表格排序(带金额单位的数字列)
    const customOpiSort = (a, b) => {
      return a.opiForSort - b.opiForSort
    }

    // 表格排序(带百分号的数字列)
    const customAmplitudeSort = (a, b) => {
      return parseFloat(a.amplitude.replace('%', '')) - parseFloat(b.amplitude.replace('%', ''))
    }

    // 表格排序(带金额单位的数字列)
    const customTurnoverSort = (a, b) => {
      return a.turnoverForSort - b.turnoverForSort
    }

    return {
      obj,
      chartDomRef,
      store,
      handleSubmit,
      handleSelectChange,
      handleRowClick,
      handleBasicValueChange,
      handleBasicDayValueChange,
      handleBasicSymbolsChange,
      handleAddBasic,
      handleTechnicalChange,
      handlePatternChange,
      handleAddTechnical,
      handleAddPattern,
      handleJRChange,
      handleJRDayChange,
      handleJRSymbolsChange,
      handleAddJR,
      del,
      cellStyle,
      customStrSort,
      customPctSort,
      customVolSort,
      customOpiSort,
      customAmplitudeSort,
      customTurnoverSort
    }
  }
}
</script>
<style lang="scss" scoped></style>